export default {
	"order.ShoppingMallPaymentResultPageAdvertisingPopUpWindow": "商城支付結果頁_廣告彈窗",
	"order.ParameterError": "參數錯誤!",
	"order.ForMoreInformationYouCanLogInToTheCallAppletOrAppToFollow": "更多信息，可登錄【叫叫】小程序或app進行關注。",
	"order.checkOrder": "查看訂單",
	"order.share": "分享",
	"order.LongPressToIdentifyTheQRCode": "長按識別二維碼",
	"order.EnterTheCallApplet": "進入叫叫小程序",
	"order.MallPaymentResultPageAdPopUpWindowClick": "商城支付結果頁_廣告彈窗點擊"
}